import { useCallback } from "react";
import { useNavigate } from 'react-router-dom';
import { resourcesBaseUri,redirectUri } from "../../config";
import { useAuth0 } from '@auth0/auth0-react';
import './Header.scss';

const Header = () => {
	const navigate = useNavigate();
	const navigateToHome = useCallback(() => {
		navigate('/');
	}, [navigate]);
	const { logout } = useAuth0();
	const logoutUser = useCallback(() => void async function() {
		const withoutTrailingSlash = redirectUri.replace(/\/+$/, '');

		logout({ returnTo: `${withoutTrailingSlash}/login` });
	}(), [logout]);

	return (
		<div className="header">
			<img
				className="header__logo"
				src={`${resourcesBaseUri}/rblogo-trans.png`}
				alt="Ritchie Bros logo"
				onClick={navigateToHome}
			/>
			<span className='header__logout-link' onClick={logoutUser}>Logout</span>
		</div>
	);
}

export default Header;